export default __webpack_public_path__ + "static/media/movings.513144a1.svg";